import React from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

const Features = ({ data, className = '' }) =>
  (<section className={className} id="features">
    <div className="container c-mw">
      <div className="row">
        <div className="col-12">
          <ul className="c-list">
            {data.map(({ icon, title, subTitle, description, subList }, i) =>
              (<div className="mb-5" key={i}>
                {icon && (
                  <div className='c-feature_icon' >
                      <FontAwesomeIcon icon={icon} />
                  </div>
                )}
                <h2 dangerouslySetInnerHTML={{ __html: title }} />
                {subTitle && (
                  <h4 className='c-light' dangerouslySetInnerHTML={{ __html: subTitle }}></h4>
                )}
                {description && (
                  <p dangerouslySetInnerHTML={{ __html: description}}></p>
                )}
                {subList && (
                  <ul>
                    {subList.map((item, j) => (
                      <li key={`${title}-${j}`} className='h5 c-regular'>
                        {item.title}
                      </li>
                    ))}
                  </ul>
                )}
              </div>),
            )}
          </ul>
        </div>
      </div>
    </div>
  </section>)

export default Features



// WEBPACK FOOTER //
// ./src/components/features/index.js